import React from "react"
import Plot from "../components/plotly"

const DeathChart = ({ data }) => {
  return (
    <Plot
      data={data}
      layout={{
        showlegend: true,
        legend: {
          orientation: "h",
          yanchor: "bottom",
          xanchor: "left",
          y: -0.2,
        },
        barmode: "stack",
        xaxis: { fixedRange: true },
        yaxis: { fixedRange: true, title: { text: "Deaths" }, side: "left" },
      }}
      onClick={event => console.log(event)}
      onSelected={event => console.log(event)}
    />
  )
}

export default DeathChart
